import { Alert } from "../../../../../../../../../mads";
import { useI18n } from "../../../../../../../../../shared/I18n";

import * as React from "react";

interface QualificationLimitNotificationProps {
  id?: string;
  handleClearError: () => void;
}

const QualificationLimitNotification = (props: QualificationLimitNotificationProps) => {
  const { gettext } = useI18n();

  const message = gettext(
    "Maximum number of qualifications reached. To save more, remove existing qualifications in your profile.",
  );

  return (
    <Alert
      status="critical"
      title={gettext("Your qualification wasn't saved")}
      explainerText={message}
      dismissAction={{
        ariaLabel: gettext("Dismiss"),
        onDismiss: props.handleClearError,
      }}
    />
  );
};

export default QualificationLimitNotification;
